export const cmsPage = {
  appWxShareBtnClick: '8254.0', // app分享按钮点击
  appWxSharePopBtnClick: '8255.0', //  app分享浮层点击
  appWxShareToFriend: '8256.0', // app点击分享到朋友
  appWxShareToFriendCircle: '8257.0', // app点击分享到朋友圈
  appWxShareCancel: '8258.0', // app取消分享
  loginBarClick: '6828.0' // 登录条点击
}
